<template>
    <div class="associated-documents">

        <transition-group tag="div" class="item-list" name="fade">

          <template v-for="(document, index) in documents" v-if="isDisplayable(index)">
            <sheet-block-associated-documents-select-item
                :key="document.type"
                :document="document"
                v-if="document.type"
            />
            <sheet-block-associated-documents-item
v-else
                :key="document.identifier"
                :document="document"

            />
          </template>


        </transition-group>
        <div class="show-more-container">
            <button
                class="button is-primary is-large is-rounded is-uppercase"
                :class="brandBackgroundColor"
                v-if="!showAll"
                @click="showAll = true"
            >
                <span>{{ $t("load_all_documents") }}</span>
                <span class="icon-plus is-tiny is-right-side"></span>
            </button>
        </div>
    </div>
</template>

<script>
    import SheetBlockAssociatedDocumentsItem from "@/components/SheetBlock/SheetBlockAssociatedDocumentsItem";
    import SheetBlockAssociatedDocumentsSelectItem from "@/components/SheetBlock/SheetBlockAssociatedDocumentsSelectItem";
    export default {
        name: 'AssociatedDocuments',
        components: {
            SheetBlockAssociatedDocumentsItem,
            SheetBlockAssociatedDocumentsSelectItem,
        },
        props: {
            documents: {
                type: Array,
                default: () => []
            },
            forceShowAll: {
                type: Boolean,
                default: false
            },
            technicalModuleLang : {
              type : Boolean,
              default : false
            }
        },
        data() {
            return {
                limit: 8,
                showAll: false
            }
        },
        computed: {
            showBtn(){
                return (this.documents.length > this.limit) && !this.forceShowAll
            }
        },
        created() {
            if(this.forceShowAll || (this.documents.length <= this.limit))
                this.showAll = true;
        },
        methods: {
            isDisplayable(index){
                return (!this.showAll && index < this.limit) || this.showAll
            },
        }
    }
</script>

<style lang="scss" scoped>
.associated-documents {
    .item-list {
        margin: 0 -10px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: left;

        @media #{$mq_phone} {
            margin: 0;
        }

        .item {
            position: relative;
            flex: 0 0 calc((100%/6) - 20px);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin: 10px;
            height: 230px;
            border-radius: 20px;
            overflow: hidden;
            box-shadow: 20px 20px 74px 0 rgba(0, 0, 0, 0.15);
            background-color: $white;
            border: solid 2px $white;
            transition: border-color 0.3s ease;

            @media #{$mq_large_desktop} {
                flex: 0 0 calc((100%/5) - 20px);
            }

            @media #{$mq_small_desktop} {
                flex: 0 0 calc((100%/4) - 20px);
            }

            @media #{$mq_tablet} {
                flex: 0 0 calc((100%/3) - 20px);
            }

            @media #{$mq_phone} {
                flex: 0 0 100%;
                margin: 0 0 20px 0;
            }

            @each $brand in $brands {
                .brand-#{$brand} & {
                    &:hover {
                        border: solid 2px brand-color($brand);
                    }
                }
            }

            .top-part {
                flex: 1 1 auto;
                display: flex;
                align-items: center;
                justify-content: center;
                height: 40%;
                width: 100%;
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;

                [class^="icon-"], [class*=" icon-"] {
                    display: block;
                    font-size: 60px;
                }
            }

            .bottom-part {
                position: relative;
                flex: 1 1 auto;
                height: 60%;
                display: flex;
                align-items: center;
                justify-content: center;
                text-align: center;
                width: 100%;

                .details {
                    .document-title {
                        font-size: 18px;
                        font-weight: 900;
                        line-height: 1;
                        margin-bottom: 10px;
                        padding: 0 20px;
                        //height: 40px;

                        @media #{$mq_small_desktop} {
                           // height: 50px;
                        }
                    }

                    [class^="icon-"], [class*=" icon-"] {
                        display: block;
                        font-size: 30px;
                    }
                }
            }
        }
    }

    .show-more-container {
        margin-top: 30px;
        text-align: center;
    }
}
</style>
